import { useCallback, useState } from "react";

// Care-plan view dialog (review-scoped, KIN-1194). openCarePlan(reviewId) opens
// for a specific review, falling back to the latest review when none is given
// (e.g. the global "View care plan" action).
export const useCarePlan = ({ latestReviewId } = {}) => {
  const [isCarePlanOpen, setIsCarePlanOpen] = useState(false);
  const [carePlanReviewId, setCarePlanReviewId] = useState(null);

  const openCarePlan = useCallback(
    (reviewId) => {
      setCarePlanReviewId(reviewId ?? latestReviewId ?? null);
      setIsCarePlanOpen(true);
    },
    [latestReviewId]
  );
  const closeCarePlan = useCallback(() => setIsCarePlanOpen(false), []);

  return { isCarePlanOpen, carePlanReviewId, openCarePlan, closeCarePlan };
};
